import React from "react";
import '../toast.css';

const LoanToastContent = ({ title, fullName, message }) => {
    return (
        <div className="toast-content">
            <strong>{title}</strong>
            <br />
            <strong>{fullName}</strong>
            <br />
            <p> {message}</p>
        </div>
    );
};

export default LoanToastContent;
